export const removeSymbolsForPhoneNumber = (str: string) =>
  str.replace(/[()-]|\s/g, '');
